<template>
	<CalendarDatePicker
		v-bind="pickerProps"
		v-model="value"
		:mode="pickerMode"
		:locale="locale"
		:is24hr="is24HourLocale"
	/>
</template>

<script>
import { DatePicker as CalendarDatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import i18n from '@/i18n'

export default {
	name: 'ProntoDatePicker',
	components: { CalendarDatePicker },
	data() {
		return { value: this.modelValue || null }
	},
	props: {
		modelValue: {
			type: [String, Date, Number],
			default: new Date(),
		},
		showTime: { type: Boolean, default: null },
		noPastDates: { type: Boolean, default: null },
		noFutureDates: { type: Boolean, default: null },
		mode: String,
		min: {
			type: [String, Date, Number],
			default: null,
		},
		max: {
			type: [String, Date, Number],
			default: null,
		},
		props: {
			type: Object,
			default: () => ({}),
		},
	},
	emits: ['update:modelValue'],
	watch: {
		modelValue(modelValue) {
			this.value = modelValue
		},
		value(value) {
			this.$emit('update:modelValue', value)
		},
	},
	computed: {
		locale() {
			return this.props.locale || i18n.global.locale
		},
		is24HourLocale() {
			return i18n.global.locale !== i18n.DEFAULT_LOCALE
		},
		minDate() {
			if (this.min) return this.min
			if (this.noPastDates) return new Date()
			return null
		},
		maxDate() {
			if (this.max) return this.max
			if (this.noFutureDates) return new Date()
			return null
		},
		pickerMode() {
			return this.showTime ? 'dateTime' : this.mode
		},
		pickerProps() {
			const props = { minuteIncrement: 5 }
			if (this.minDate && !props.minDate) {
				props.minDate = this.minDate
			}
			if (this.maxDate && !props.maxDate) {
				props.maxDate = this.maxDate
			}
			return Object.assign({}, props, this.props)
		},
	},
}
</script>
<style lang="scss">
@import 'src/sass/variables';

.vc-base-select {
	select {
		border: 0;
	}
}

@include overrideScheme('dark') {
	--pronto-green: var(
		--teal-300
	); // this avoids a collision with the VC --teal-300 variable
	.vc-container {
		background-color: var(--neutral-200);
		border-color: var(--neutral-200);
		.vc-title span,
		.in-month span {
			color: white !important;
		}
		.vc-select select,
		.vc-am-pm {
			background-color: var(--neutral-100);
			border-color: var(--neutral-100);
			color: var(--neutral-800);
		}
		.vc-am-pm {
			button:not(.active) {
				color: var(--neutral-800);
			}
			button.active {
				background-color: var(--pronto-green);
			}
		}
		.vc-time-picker {
			border-color: var(--neutral-100);
		}
		.vc-highlight {
			background-color: var(--pronto-green) !important;
		}
		.vc-day-content {
			color: white !important;
			&.vc-disabled {
				color: var(--neutral-500) !important;
			}
		}
		.vc-date {
			.vc-month,
			.vc-day {
				color: var(--pronto-green);
			}
		}
		.vc-title {
			background-color: var(--blue-300);
			border-radius: 5px;
		}
		.vc-arrow:not(.is-disabled) {
			background-color: var(--blue-300);
			border-radius: 5px;
			color: white;
			svg {
				stroke: white;
			}
			&:hover {
				background-color: var(--blue-400);
			}
		}
	}
}
</style>
